/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ groupName: NonNullable<unknown> }} Confirm_Delete_GroupInputs */

const fr_confirm_delete_group = /** @type {((inputs: Confirm_Delete_GroupInputs) => LocalizedString) & { parts: (inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Confirm_Delete_GroupInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Êtes-vous sûre de vouloir supprimer le groupe ${i?.groupName}.

L'ensemble de ses utilisateur(s), bâtiment(s) et groupe(s) utilisateurs seront déplacés vers son groupe parent.`)
		}),
		{
			parts: /** @type {(inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Êtes-vous sûre de vouloir supprimer le groupe " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.groupName) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: ".\n\nL'ensemble de ses utilisateur(s), bâtiment(s) et groupe(s) utilisateurs seront déplacés vers son groupe parent." }])
			})
		}
	)
);

const en_confirm_delete_group = /** @type {((inputs: Confirm_Delete_GroupInputs) => LocalizedString) & { parts: (inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Confirm_Delete_GroupInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Are you sure you want to delete the group ${i?.groupName}.

All of its user(s), building(s) and user group(s) will be moved to its parent group.`)
		}),
		{
			parts: /** @type {(inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Are you sure you want to delete the group " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.groupName) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: ".\n\nAll of its user(s), building(s) and user group(s) will be moved to its parent group." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Are you sure you want to delete the group {groupName}. All of its user(s), building(s) and user group(s) will be moved to its parent group." |
*
* @param {Confirm_Delete_GroupInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_delete_group = /** @type {((inputs: Confirm_Delete_GroupInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Confirm_Delete_GroupInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Confirm_Delete_GroupInputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Confirm_Delete_GroupInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_confirm_delete_group(inputs)
			return fr_confirm_delete_group(inputs)
		}),
		{
			parts: /** @type {(inputs: Confirm_Delete_GroupInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[] }} */ (en_confirm_delete_group).parts?.(inputs) ?? [{ type: "text", value: en_confirm_delete_group(inputs) }]
				return /** @type {{ parts?: (inputs: Confirm_Delete_GroupInputs) => import('../runtime.js').MessagePart[] }} */ (fr_confirm_delete_group).parts?.(inputs) ?? [{ type: "text", value: fr_confirm_delete_group(inputs) }]
			})
		}
	)
);